import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputComponent from "../../components/Input";
import ButtonComponent from "../../components/Button";
import { useDispatch } from "react-redux";
import { AddWalletBalanceAction } from "../../store/actions/user-action";

const AddWalletBalancePage = () => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      walletAmount: "",
      mobileNumber: "",
    },
    validationSchema: Yup.object({
      walletAmount: Yup.number()
        .typeError("Wallet balance must be a number")
        .required("Wallet balance is required")
        .positive("Wallet balance must be greater than zero"),
      mobileNumber: Yup.string()
        .required("Mobile number is required")
        .matches(
          /^\s*\d{10}(?:\s*,\s*\d{10})*\s*$/,
          "Enter one or more valid 10-digit mobile numbers separated by commas"
        ),
    }),
    onSubmit: (values) => {
      const mobileNumberList = values.mobileNumber
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
        .map(Number);

      dispatch(
        AddWalletBalanceAction(
          {
            mobileNumber: mobileNumberList,
            walletAmount: Number(values.walletAmount),
          },
          formik
        )
      );
    },
  });

  return (
    <div className="p-[25px] rounded-md border bg-white max-w-3xl">
      <h3 className="font-medium">Add Wallet Balance</h3>
      <p className="text-sm text-[#595858] mt-2">
        Add wallet balance for one or more users by mobile number.
      </p>
      <form className="mt-5" onSubmit={formik.handleSubmit}>
        <div className="grid gap-6 md:grid-cols-2">
          <div>
            <label className="block text-sm font-medium text-gray-900">
              Wallet Balance
            </label>
            <InputComponent
              type="number"
              name="walletAmount"
              placeholder="Enter wallet amount"
              value={formik.values.walletAmount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.walletAmount && formik.errors.walletAmount}
            />
            {formik.touched.walletAmount && formik.errors.walletAmount && (
              <div className="text-red-500 text-sm">
                {formik.errors.walletAmount}
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-900">
              Mobile Number(s)
            </label>
            <InputComponent
              type="text"
              name="mobileNumber"
              placeholder="Enter mobile numbers separated by commas"
              value={formik.values.mobileNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.mobileNumber && formik.errors.mobileNumber}
            />
            {formik.touched.mobileNumber && formik.errors.mobileNumber && (
              <div className="text-red-500 text-sm">
                {formik.errors.mobileNumber}
              </div>
            )}
          </div>
        </div>
        <div className="mt-6 text-right">
          <ButtonComponent text="Submit" />
        </div>
      </form>
    </div>
  );
};

export default AddWalletBalancePage;
